<template>
  <div class="body_right">
    <div class="body_right_first">
      <div class="img"><img src="@/assets/imgs/icon_open.png"></div>
      <div class="title">帮助与反馈</div>
    </div>
    <div class="body_right_second">
      <help-item v-for="(item,index) in list" :key="index" :data="item" :sortI="index"></help-item>
      <div class="body_right_second_feedback">
        <div class="body_right_second_feedback_top">
          <div>
            问题反馈：
          </div>
          <div>
            <el-radio v-model="radio" label="1">製品利用</el-radio>
            <el-radio v-model="radio" label="2">bug</el-radio>
            <el-radio v-model="radio" label="3">コンテンツ</el-radio>
          </div>
        </div>
        <div class="body_right_second_feedback_textarea">
          <el-input
            type="textarea"
            resize="none"
            maxlength="150"
            placeholder="質問事項などご意見を入力"
            v-model="textarea">
          </el-input>
          <div class="suffix">{{textarea.length}}/150</div>
          <div class="btn" @click="feedbackAdd()">送信</div>
          <div class="img_upload">
            <el-upload
              class="avatar-uploader"
              action="http://47.242.180.16:8085/file/upload"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as json from '@/assets/js/json'
  import helpItem from '@/components/helpItem/index'
  export default {
    components: {
      helpItem
    },
    data () {
      return {
        list:[{
          Q: 'スマートフォンから記事を投稿するには？',
          A: 'トップページで画面下中央に表示される+マークをタップして「記事投稿」を選択します。画面上部のジャンルをタップして記事のジャンルを選び、タイトルと本文、あれば写真を追加して投稿します。記事の文字数は500字以内です。投稿は審査を経て反映されます。'
        },{
          Q: '「動画」で投稿するには？',
          A: 'トップページで画面下中央に表示される+マークをタップして「動画を投稿」を選択します。画面上部のジャンルをタップして動画のジャンルを選び、タイトルと本文、動画（1GB以下）を追加して投稿します。審査を経て反映されます。'
        },{
          Q: '「発見」で投稿するには？',
          A: 'トップページで画面下中央に表示される+マークをタップして「発見投稿」を選択します。本文の他に、カメラで撮影した写真及び、スマホのアルバムの中に保存された写真を選択して投稿できます。'
        },{
          Q: '500字以上の投稿をするには？',
          A: '文字数が500字以上の投稿を行う場合、外部投稿システムをご利用ください。PCのブラウザでhttps://mp.hojinnavi.comにアクセスし、所定のIDとパスワードで操作画面にログインして下さい。'
        },{
          Q: '投稿に失敗しました。',
          A: 'インターネット接続の異常など、動作環境をご確認下さい。それでも改善しない場合は、アプリを再起動して下さい。'
        },{
          Q: '一つの記事に何点まで画像を添付できますか?',
          A: '投稿できる写真は９枚までです。'
        },{
          Q: '投稿した内容は修正できますか？',
          A: '現在、修正・削除を投稿者がすることはできません。カスタマーデスクまでご連絡下さい。'
        },{
          Q: '記事をトップに配置することはできますか？',
          A: '投稿者が選択することはできません。'
        },{
          Q: '投稿できる記事に文字制限はありますか？',
          A: '投稿できる文字数は500文字までです。'
        },{
          Q: '投稿規約を教えてください。',
          A: '「マイ」→「設定」→「邦人NAVI」について→利用規約でご確認いただけます。'
        },{
          Q: 'コメントの読み込みができません/コメントが追加できません。',
          A: '下方向にスワイプして画面の更新を行って下さい。それでも更新されない場合は、アプリを再起動して下さい。'
        },{
          Q: '記事の作者に「いいね」するには？',
          A: '記事の下部に表示されている「作者にいいね」をタップしてください。'
        },{
          Q: '「いいね」ができません。',
          A: '下方向にスワイプして画面の更新を行って下さい。それでも更新されない場合は、アプリを再起動して下さい。'
        },{
          Q: '記事に「いいね」するには？。',
          A: '記事の最下部に表示されている親指マークをタップして下さい。'
        },{
          Q: '投稿をシェアするには？',
          A: '画面右上の（…）をタップし、共有先を選択すると投稿内容をシェアすることができます。'
        },{
          Q: '投稿のシェアができません。',
          A: '下方向にスワイプして画面の更新を行って下さい。それでも更新されない場合は、アプリを再起動して下さい。'
        }],
        radio: '1',
        textarea: '',
        imageUrl: null
      }
    },
    created () {
    },
    methods: {
      handleAvatarSuccess(res, file) {
        this.imageUrl = res.data.url
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      feedbackAdd(){
        if(this.textarea==''&&this.textarea==null){
          return
        }
        let  options = {
            images: this.imagesUrl,
            content: this.textarea,
            state: 'UNRESOLVED',
            type: this.radio
          }
        json.post('/api/member/feedback/add', options).then((res) => {
          if (res.data.success) {
            this.imageUrl = null
            this.textarea = ''
          }
        })
      }
    },
  }
</script>

<style src="@/pages/homePage/notice/likeNotice/index.css" scoped>
</style>
<style scoped>
  .body_right_second_feedback{
    width: 822px;
    margin: 0 auto;
    margin-top: 44px;
  }
  .body_right_second_feedback_top{
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 16px;
  }
  .body_right_second_feedback_top div{
    display: inline-block;
    vertical-align: middle;
  }
  .body_right_second_feedback_top div:first-child{
    margin-left: 24px;
    margin-right: 42px;
  }
  .body_right_second_feedback_textarea{
    width: 822px;
    height: 204px;
    border: 1px solid #CCCCCC;
    border-radius: 5px;
    margin-top: 17px;
    position: relative;
  }
  ::v-deep .body_right_second_feedback_textarea .el-textarea__inner{
    height: 160px;
  }
  .body_right_second_feedback_textarea .btn{
    width: 88px;
    height: 31px;
    background: #FFFFFF;
    border: 1px solid #CCCCCC;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 31px;
    text-align: center;
    position: absolute;
    bottom: 23px;
    right: 30px;
    cursor: pointer;
  }
  /* 选中后的字体颜色 */
  ::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: #FF9966 !important;
  }
  /* 选中后圆圈的背景颜色 */
  ::v-deep .el-radio__input.is-checked .el-radio__inner {
  background: #FF9966 !important;
  border-color: #FF9966 !important;
  }
  ::v-deep .el-radio__input.is-checked .el-radio__inner::after {
  background: #fff !important;
  }
  .suffix {
    font-size: 16px;
    font-weight: 300;
    color: #999999;
    line-height: 16px;
    position: absolute;
    bottom: 31px;
    right: 142px;
  }
  .img_upload{
    width: 64px;
    height: 64px;
    border: 1px dashed #CCCCCC;
    border-radius: 5px;
    position: absolute;
    bottom: 22px;
    left: 24px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 64px;
    height: 64px;
    line-height: 64px;
    text-align: center;
  }
  .avatar {
    width: 64px;
    height: 64px;
    display: block;
  }
</style>

